import React from 'react'
import { AltText, Images, Regex } from '@/constants'

import styles from './styles.scss'

export const SEARCH_BAR_FIELD = {
  fromDate: 'fromDate',
  toDate: 'toDate',
  destination: 'destination',
  children: 'children',
  adults: 'adults',
}

export const VALIDATION = {
  [SEARCH_BAR_FIELD.fromDate]: v => !Regex.formattedDate.test(v),
  [SEARCH_BAR_FIELD.toDate]: v => !Regex.formattedDate.test(v),
  [SEARCH_BAR_FIELD.destination]: v => !v,
  [SEARCH_BAR_FIELD.adults]: v => !v > 0,
  [SEARCH_BAR_FIELD.children]: (v) => !v.map(a => !parseInt(a.value, 10) > 0).every(p => p),
}

const wrapImage = imageEl => (
  <div className={styles.orangeFill} style={{ height: 'auto' }}>
    <div className={styles.imgWrapper} style={{ height: 'auto' }}>
      {imageEl}
    </div>
  </div>
)

const ACCESSORIES = {
  packageDeal: {
    active: (
      <>
        {wrapImage(<img src={Images.whiteHotel} alt={AltText.hotelActive} />)}
        <span> + </span>
        {wrapImage(<img src={Images.whitePlane} alt={AltText.flightActive} />)}
      </>
    ),
    inactive: (
      <>
        {wrapImage(<img src={Images.orangeHotel} alt={AltText.hotelInactive} />)}
        <span> + </span>
        {wrapImage(<img src={Images.orangePlane} alt={AltText.flightInactive} />)}
      </>
    ),
  },
  flight: {
    active: wrapImage(<img src={Images.whitePlane} alt={AltText.flightActive} />),
    inactive: wrapImage(<img src={Images.orangePlane} alt={AltText.flightInactive} />),
  },
  hotel: {
    active: wrapImage(<img src={Images.whiteHotel} alt={AltText.flightActive} />),
    inactive: wrapImage(<img src={Images.orangeHotel} alt={AltText.flightInactive} />),
  },
}

export default ACCESSORIES
